import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useNavigationView } from '../../../design-system';
import { mainNav } from '../../navView';
import { JobView } from './Job';
import JobsList from './JobsList';

const JobsView: React.FC = () => {
  const { path } = useRouteMatch();
  useNavigationView(mainNav);

  return (
    <Switch>
      <Route path={`${path}/:jobId`}>
        <JobView />
      </Route>

      <Route>
        <JobsList />
      </Route>
    </Switch>
  );
};

export default JobsView;
